module.exports = __webpack_public_path__ + "static/media/FrutigerNeueLTW04-Book.e815cf26.woff2";